import { render, staticRenderFns } from "./RiskCodeForm.vue?vue&type=template&id=4ff6eece&"
import script from "./RiskCodeForm.vue?vue&type=script&lang=js&"
export * from "./RiskCodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports